<mat-tab-group animationDuration="400ms">
  <mat-tab label="Associados">
    <div class="py-2 mb-3">
      @if (true) {
        <form-client-search
          [search]="inputSearchClient"
          [listSearch]="listSearch"
          (responseSearch)="search($event, 'TClient')"
        />
      }
      @if (!loadingClient) {
        @if (totalClient > 0) {
          <div>
            <table-list-consultant
              [dataSource]="listClient"
              [columns]="columnsClient"
              [loading]="loadingBIcon"
              [listClient]="true"
              (addItemEvent)="addItem($event)"
              (removeItemEvent)="removeItem($event)"
            />
          </div>
        } @else {
          <div>
            <h3 class="text-center">Nenhum cliente associado.</h3>
          </div>
        }
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      <div [hidden]="loadingClient || totalClient == 0">
        <mat-paginator
          #paginatorClient
          [length]="totalClient"
          [pageSizeOptions]="[1, 5, 10, 20, 50]"
          [pageSize]="rowsClient"
          [pageIndex]="pageClient - 1"
          (page)="pageChanged($event, 'TClient')"
        >
        </mat-paginator>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Não associados">
    <div class="py-2 mb-3">
      @if (true) {
        <form-client-search
          [search]="inputSearchNotClient"
          [listSearch]="listSearch"
          (responseSearch)="search($event, 'TNClient')"
        />
      }
      @if (!loadingNotClient) {
        @if (totalNotClient > 0) {
          <div>
            <table-list-consultant
              [dataSource]="listNotClient"
              [columns]="columnsNotClient"
              [loading]="loadingBIcon"
              [listClient]="true"
              (addItemEvent)="addItem($event)"
              (removeItemEvent)="removeItem($event)"
            />
          </div>
        } @else {
          <div>
            <h3 class="text-center">Nenhum cliente.</h3>
          </div>
        }
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      <div [hidden]="loadingNotClient || totalNotClient == 0">
        <mat-paginator
          #paginatorNotClient
          [length]="totalNotClient"
          [pageSizeOptions]="[1, 5, 10, 20, 50]"
          [pageSize]="rowsNotClient"
          [pageIndex]="pageNotClient - 1"
          (page)="pageChanged($event, 'TNClient')"
        >
        </mat-paginator>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
